// extracted by mini-css-extract-plugin
export default {"label":"select_label__wdgHI","star":"select_star__GqPeQ","input":"select_input__pfBcj","error_msg":"select_error_msg__+A5O3"};